export default "__VITE_ASSET__276cb944__"